import React from 'react';
import { Avatar, Box, IconButton, Menu, MenuItem, Typography } from '@mui/material';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import { useNavigate } from 'react-router-dom';
import { logout } from '../services';

function Topbar({ mobile, onMenuClick, sidebarCollapsed, sidebarOpen, session, title }) {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const identity = session?.displayName || session?.username || 'Usuario';
  const initial = identity.trim()[0]?.toUpperCase() || 'U';

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }

    navigate('/');
  };

  const handleLogout = async () => {
    setAnchorEl(null);
    try {
      await logout();
    } finally {
      navigate('/login', { replace: true });
    }
  };

  const menuTitle = mobile
    ? sidebarOpen
      ? 'Cerrar menu'
      : 'Abrir menu'
    : sidebarCollapsed
      ? 'Mostrar menu lateral'
      : 'Ocultar menu lateral';

  return (
    <Box component="header" className="suite-topbar">
      <Box className="suite-topbar-left">
        <Box className="suite-topbar-navigation">
          <IconButton
            aria-label={menuTitle}
            onClick={onMenuClick}
            className="suite-icon-button"
            title={menuTitle}
          >
            <MenuRoundedIcon />
          </IconButton>
          <IconButton
            aria-label="Volver atras"
            onClick={handleBack}
            className="suite-icon-button"
            title="Volver atras"
          >
            <ArrowBackRoundedIcon />
          </IconButton>
        </Box>
        <Typography className="suite-breadcrumb">{title}</Typography>
      </Box>

      <Box className="suite-topbar-actions">
        <Box
          className="suite-user-menu"
          onClick={(event) => setAnchorEl(event.currentTarget)}
        >
          <Avatar className="suite-user-avatar">{initial}</Avatar>
          <Typography className="suite-user-name">{identity}</Typography>
          <ExpandMoreRoundedIcon sx={{ fontSize: 19 }} />
        </Box>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <MenuItem onClick={handleLogout}>
            <LogoutRoundedIcon fontSize="small" sx={{ mr: 1 }} />
            Cerrar sesion
          </MenuItem>
        </Menu>
      </Box>
    </Box>
  );
}

export default Topbar;
